var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":`0 0 ${_vm.width} ${_vm.height}`,"role":"presentation","fill":"none"}},[_c('path',{attrs:{"d":"M2.5 2.29688L17 16.7969L31.5 2.29688","stroke":"currentColor","stroke-width":"3","stroke-linecap":"square"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }